import React, { useEffect } from 'react';
import { RouterWrapper } from './styled';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StyleSheetManager } from 'styled-components';
import { ConfigProvider } from 'antd';
import theme from '../routers/localTheme';
import RouteUser from './RouteUser';
import { Navigate, Route, Routes } from 'react-router-dom';
import 'antd/dist/reset.css';
import '../styles/index.less';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { handleDarkAlphaTheme, initSensor } from '@pulse/nav';
import Legal from '@src/pages/Legal/Legal';
import Login from './auth/Login';
import ActivatePage from './auth/ActivatePage';
import RegeneratePage from './auth/RegeneratePage';
import ChangePasswordPage from './auth/ChangePasswordPage';
// import ForgotPasswordPage from './auth/ForgotPasswordPage';
import ResetPasswordPage from './auth/ResetPasswordPage';
import CustomerSwitch from '@src/pages/CustomerSwitch';
import PageNotFound from '@src/components/common/PageNotFound';

const queryClient = new QueryClient();

export const BaseApp = ({ container }) => {
  useEffect(() => {
    handleDarkAlphaTheme();
    initSensor({ env: process.env.NODE_CONFIG_ENV as any });
  }, []);

  return (
    <StyleSheetManager disableCSSOMInjection={true} target={container}>
      <ConfigProvider
        theme={theme}
        // mount within the app space for dark mode
        getPopupContainer={(): any => document.getElementById('ifc-portals')}
      >
        <QueryClientProvider client={queryClient}>
          <RouterWrapper id="router-wrapper">
            <Routes>
              <Route path={`/legal/*`} element={<Legal />} />
              <Route path={`/`} element={<Navigate to="/login" replace />} />
              <Route path={`/login`} element={<Login />} />
              <Route path={`/auth/activate/:token`} element={<ActivatePage />} />
              <Route path={`/auth/regenerate`} element={<RegeneratePage />} />
              {/* <Route path={`/auth/forgot-password`} element={<ForgotPasswordPage />} /> */}
              <Route path={`/auth/reset_password/:token`} element={<ResetPasswordPage />} />
              <Route path={`app/pulse/settings/change_password`} element={<ChangePasswordPage />} />
              <Route path="/customer_switch/:customerId" element={<CustomerSwitch />} />
              {/* <Route path={`/app/pulse/:subpath/*`} element={<LegacyPulseLoader />} /> */}
              <Route path={`/app/*`} element={<RouteUser />} />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
            <ReactQueryDevtools initialIsOpen={false} />
          </RouterWrapper>
        </QueryClientProvider>
      </ConfigProvider>
    </StyleSheetManager>
  );
};

export default BaseApp;
